{
  "headings": {
    "login": "Connectez-vous",
    "forgotten": "J'ai oublié mon mot de passe",
    "confirmation": "E-mail envoyé",
    "sending": "Envoi d'e-mails...",
    "setPass": "Définissez votre mot de passe",
    "startYourFreeTrial": "Commencez votre essai gratuit."
  },
  "subHeadings": {
    "freeTrial": "Essai gratuit de 30 jours. Aucune carte de crédit n'est requise.",
    "login": "Pour accéder à votre compte Iventis, commencez par saisir votre adresse e-mail.",
    "forgotten": "Entrez l'adresse e-mail associée à votre compte Iventis et nous vous enverrons un e-mail pour réinitialiser votre mot de passe.",
    "confirmation": "Consultez vos e-mails pour trouver un lien permettant de réinitialiser votre mot de passe. L'arrivée peut prendre jusqu'à 10 minutes.",
    "confirmationCode": "Vérifiez votre e-mail pour obtenir un code de vérification pour votre nouveau compte. L'arrivée peut prendre jusqu'à 10 minutes.",
    "setPass": "Entrez un nouveau mot de passe pour votre compte ci-dessous."
  },
  "labels": {
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "projectName": "Nom du projet",
    "email": "Adresse e-mail",
    "password": "Mot de passe",
    "confirmPass": "Répétez le mot de passe",
    "verificationCode": "Code de vérification"
  },
  "placeholders": {
    "email": "Entrez votre adresse e-mail",
    "password": "Entrez votre mot de passe",
    "passwordCreate": "Entrez le mot de passe",
    "passwordConfirm": "Saisissez à nouveau le mot de passe"
  },
  "links": {
    "signIn": "Connectez-vous",
    "forgotPass": "J'ai oublié mon mot de passe",
    "sendAgain": "Envoyer à nouveau",
    "termsAndCo": "Termes et conditions",
    "back": "Retour",
    "register": "S'inscrire",
    "loginWithEmail": "Connectez-vous par e-mail à la place",
    "loginWithSingleSignOn": "Connectez-vous avec Single Sign-On",
    "loginWithMicrosoft": "Connectez-vous avec votre compte Microsoft"
  },
  "options": {
    "alreadyHaveAccount": "Vous avez déjà un compte Iventis ?",
    "dontHaveAccount": "Vous n'avez pas de {{ ssoProviderName }}",
    "dontHaveIventis": "Vous n'avez pas de compte Iventis ?",
    "rememberDetails": "Mémoriser mes coordonnées",
    "notReceived": "Vous n'avez pas reçu d'e-mail ?",
    "consentTos1": "En créant ce compte, j'accepte",
    "consentTos2": "de la plateforme Iventis.",
    "verified": "Code vérifié avec succès ! Votre compte est désormais actif."
  },
  "passwordConditions": {
    "min8characters": "Minimum de 8 caractères",
    "lowercaseLetter": "Contient une lettre minuscule",
    "uppercaseLetter": "Contient une lettre majuscule",
    "digit": "Contient un numéro"
  },
  "buttons": {
    "continue": "Continuer",
    "login": "Connectez-vous",
    "sendLink": "Envoyer le lien de réinitialisation",
    "createAccount": "Créer un compte"
  },
  "footer": {
    "terms": "Conditions d'utilisation",
    "policy": "Politique de confidentialité",
    "contact": "Nous contacter"
  },
  "error": {
    "invalidCode": "Code non valide.",
    "unknownError": "Quelque chose s'est mal passé",
    "failed": "Impossible de définir le mot de passe. Réessayez, s'il vous plaît.",
    "required": "Nécessaire",
    "invalid": "Adresse e-mail non valide",
    "cantFindEmail": "Nous ne trouvons aucun compte Iventis associé à cette adresse e-mail. Réessayez ou créez un compte.",
    "passwordTooLong": "Le mot de passe peut contenir au maximum 64 caractères",
    "passwordsMustMatch": "Les mots de passe ne correspondent pas",
    "mustAgreeToTC": "Pour créer un compte, vous devez accepter nos conditions générales",
    "resetPasswordLinkInvalidTitle": "Lien expiré",
    "resetPasswordLinkInvalid": "Le lien permettant de réinitialiser votre mot de passe n'était pas valide ou a expiré. Nous avons envoyé un nouveau lien à l'adresse e-mail associée à votre compte. Si vous ne recevez pas de nouveau lien, essayez d'utiliser le lien « mot de passe oublié » ci-dessous ou contactez",
    "emailInUse": {
      "0": "Cette adresse e-mail est déjà utilisée.",
      "1": "Cliquez ici",
      "2": "pour vous connecter"
    }
  }
}